defineDs('DanskeSpil/Domain/PlayTogether/Scripts/Templates/ViewClub/ActivityFeed/NormalCard',
  [
    'Shared/Framework/Mithril/Scripts/Core/Mithril',
    'DanskeSpil/Domain/PlayTogether/Scripts/Helpers/Utils',
    'DanskeSpil/Domain/PlayTogether/Scripts/Templates/Common/Avatar',
    'DanskeSpil/Domain/PlayTogether/Scripts/Templates/Common/PostCard',
    'DanskeSpil/Domain/PlayTogether/Scripts/Templates/Common/CtaButton'
  ],
  function (m, Utils, Avatar, PostCard, CtaButton) {
    const feedTypeWithAvatar = ['PlayerJoined', 'PlayerLeft', 'GroupChangeChairman', 'GroupChangeRules'];

    // View:
    var NormalCard = {
      controller: function ({ controller }) {
        Object.assign(this, controller);

        this.dictionary = this.rootDictionary.get.bind({ prefix: 'ViewClub/ActivityFeed/' });
      },
      view: function (controller, { feedPost, index }) {
        const feedContent = feedPost.message;
        const $header = [];
        const $footer = [];

        if (feedContent.callToActionText) {
          $footer.push(CtaButton({
            text: feedContent.callToActionText,
            href: feedContent.callToActionUrl,
            options: ['primary']
          }));
        }

        if (feedTypeWithAvatar.includes(feedPost.type)) {
          $header.push(Avatar({
            name: feedPost.playerName,
            isChairman: feedPost.type === 'GroupChangeChairman'
          }));
        }

        if (feedPost.type === 'GameFunded') {
          let drawsCountLabel = 'GameFunded/WeeksCountLabel';
          if (feedPost.gameType === 'EuroJackpot') {
            drawsCountLabel = 'GameFunded/DrawsCountLabel';
          }
          const detailItem = ({ icon, description }) => {
            return m('.play-together-club-activity-feed__funding-detail', [
              m('svg.play-together-club-activity-feed__funding-detail-icon', [
                m('use', { href: `/Components/DanskeSpil/Domain/PlayTogether/Graphics/SpriteSheets/PlayTogetherIcons.svg#${icon}` })
              ]),
              m('.play-together-club-activity-feed__funding-detail-description', description)
            ]);
          };
          const fundingDetails = m('.play-together-club-activity-feed__funding-details', [
            detailItem({
              icon: 'card_with_rows_tilted',
              description: [controller.dictionary('GameFunded/RowsCountLabel'), m('strong', feedPost.rowCount / feedPost.numberOfDraws)]
            }),
            detailItem({
              icon: 'coins',
              description: [controller.dictionary('GameFunded/StakeAmountLabel'), m('strong', Utils.formatCurrency(feedPost.stakeAmount))]
            }),
            detailItem({
              icon: 'coupon-calendar',
              description: [controller.dictionary(drawsCountLabel), m('strong', feedPost.numberOfDraws)]
            })
          ]);

          $header.push(m('svg.play-together-club-activity-feed__row-icon', [
            m('use', { href: '/Components/DanskeSpil/Domain/PlayTogether/Graphics/SpriteSheets/PlayTogetherIcons.svg#card_with_rows_and_checkmark' })
          ]));
          $footer.push(fundingDetails);
        }

        const postCardOptions = {
          title: feedContent.header,
          description: feedContent.message,
          $header: $header,
          $footer: $footer,
          keyIndex: index
        };

        // View:
        return PostCard(postCardOptions);
      }
    };

    // Public functions:
    return NormalCard;

  });
